/* eslint-disable no-unused-vars */
import { getStore } from "./../stores/base.js";
import { errorMsg, msgData } from "./utils.js";

export const getFormItem = (instanceId, data) => {
  try {
    let fieldValue;
    let useFormStore = getStore(instanceId);
    if (data.tableId && data.rowId) {
      fieldValue = useFormStore
        .getState()
        .formData.getList(data.tableId)
        .find((row) => row.id === data.rowId)
        .getValue(data.fieldId);
    } else {
      fieldValue = useFormStore.getState().formData.getValue(data.fieldId);
    }
    if (fieldValue !== undefined) {
      return msgData(data, {
        fieldValue: fieldValue
      });
    }
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const getTable = (instanceId, data) => {
  try {
    return msgData(data, {
      instanceId,
      tableId: data.tableId
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const getTableRow = (instanceId, data) => {
  try {
    let useFormStore = getStore(instanceId);
    let { tableId, rowId } = data;
    let tableRow = useFormStore
      .getState()
      .formData.getList(tableId)
      .find((row) => row.id === rowId);
    return msgData(data, {
      tableRow
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const updateFormItem = (instanceId, data) => {
  try {
    let useFormStore = getStore(instanceId);
    const updateFormField = useFormStore.getState().updateField;
    const updateTableField = useFormStore.getState().updateTableField;
    let args = data.data;
    for (let key in args) {
      if (data.tableId) {
        let fieldDetails = useFormStore
          .getState()
          .modelConfig[data.tableId].find((row) => row.Id === key);
        updateTableField(
          data.tableId,
          data.rowId,
          { Id: key, modelConfig: fieldDetails },
          args[key],
          true
        );
      } else {
        updateFormField(args[key], { Id: key }, true);
      }
    }
    return msgData(data, { message: "Updated successfully" });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const addTableRow = async (instanceId, data) => {
  try {
    const { rowObject, tableId } = data;
    const useFormStore = getStore(instanceId);
    await useFormStore.getState().addTableRow({ tableId, data: rowObject });
    return msgData(data, { message: "Updated successfully" });
  } catch (e) {
    console.error(e);
    return errorMsg(data, e);
  }
};

export const addTableRows = async (instanceId, data) => {
  try {
    const { rows, tableId } = data;
    const useFormStore = getStore(instanceId);
    await useFormStore.getState().addTableRows({ tableId, data: rows });
    return msgData(data, { message: "Updated successfully" });
  } catch (err) {
    return errorMsg(data, err);
  }
};

export const deleteTableRow = async (instanceId, data) => {
  try {
    let useFormStore = getStore(instanceId);
    let { tableId, rows = [] } = data;
    await useFormStore.getState().deleteTableRow(tableId, rows);
    return msgData(data, { message: "deleted successfully" });
  } catch (e) {
    console.error(e);
    return errorMsg(data, e);
  }
};

export const getTableRows = (instanceId, data) => {
  try {
    let useFormStore = getStore(instanceId);
    let { tableId } = data;
    let tableRow = useFormStore.getState().formData.getList(tableId);
    return msgData(data, {
      tableRow
    });
  } catch (e) {
    console.error(e);
    return errorMsg(data, e);
  }
};

export const getSelectedRows = (instanceId, data) => {
  try {
    let useFormStore = getStore(instanceId);
    let selectedRows =
      useFormStore.getState().tableSelectedRows[data.tableId] || [];
    let selectedRowsData = [];
    if (selectedRows.length > 0) {
      let tableJSONData = getJSONData(useFormStore, { tableId: data.tableId });
      selectedRowsData = tableJSONData.filter(
        (item) =>
          selectedRows.findIndex((selected) => selected.id === item._id) > -1
      );
    }
    return msgData(data, {
      selectedRowsData
    });
  } catch (e) {
    console.error(e);
    return errorMsg(data, e);
  }
};

export const toJsonForm = (instanceId, data) => {
  try {
    let useFormStore = getStore(instanceId);
    let jsonData = getJSONData(useFormStore, data);
    return msgData(data, {
      jsonData
    });
  } catch (e) {
    console.error(e);
    return errorMsg(data, e);
  }
};

const getJSONData = (storeRef, data) => {
  const { tableId, rowId } = data;
  let formJson = storeRef.getState().toJSON();
  let jsonData = {};
  let metaTableId = `Table::${tableId}`;
  if (formJson) {
    if (rowId) {
      jsonData = formJson.dataSet[metaTableId].find((row) => row._id === rowId);
    } else if (tableId) {
      jsonData = formJson.dataSet[metaTableId];
      if (!jsonData && formJson.getChangeSummary()[metaTableId]) {
        jsonData = [];
      }
    } else {
      jsonData = formJson.dataSet;
    }
  }
  return jsonData;
};
